import { Injectable } from '@angular/core';
import { MenuService } from '../shared/header/menu/menu.service';
import { TranslateService } from '@ngx-translate/core';
import { PageGuideService } from '../page-guide/page-guide.service';

@Injectable({
    providedIn: 'root'
})
export class BootstrapService {

    constructor(private menuService: MenuService, private pageGuideService: PageGuideService, private translateService: TranslateService) {}
    
    bootstrap(token: string) {

        this.menuService.fetchMenu(this.translateService.currentLang, token);
        this.pageGuideService.startPageGuide();
    }
}